( function() {

	var $ = require('jquery');

	// Ajax call for modal presenting event & speaker info
	$('.program__row').on('click', '.program__link',  function(event) {

		event.preventDefault();
		$(this).toggleClass('program__link--active');
		$('.program__block').removeClass('program__block--active');
		$(this).parents('.program__block').toggleClass('program__block--active');
		$('.program__info').removeClass('program__info--active');

		var data_id = $(this).data('id');
		var post_id = $(this).data('program');
		var start = $(this).data('start');
		var end = $(this).data('end');
		var speakerId = $(this).data('speaker');

		$.ajax({
			url : getprogram.ajax_url,
			type : 'post',
			data : {
				action : 'wd_get_program',
				post_id : post_id,
				start : start,
				end : end,
				speakerId : speakerId,
			},
			success : function( response ) {

				$('#' + data_id).html( response ).addClass('program__info--active');
			}
		});
	});




	// Toggle day
	$('.program__nav-button').on('click', function(event) {
		event.preventDefault();
		var displayDay = "#" + $(this).data('day');
		$(displayDay).show().siblings().hide();
		$('.program__nav-button').removeClass('program__nav-button--active');
		$('#first-' + $(this).data('day')).addClass('program__nav-button--active');
		$('#second-' + $(this).data('day')).addClass('program__nav-button--active');
	});

	$('.program__nav-button').first().click();

})();
